import React from 'react';
import { Fragment } from 'react';
import { ListGroupItem } from "@/design-system/native";
import { sanitize } from "@/lib/sanitize";

const LI = (props) =>{
   return (
     <Fragment>
       <ListGroupItem {...props.attrLI}>{props.val? <div dangerouslySetInnerHTML={{ __html: sanitize(props.val) }}/> :''} {props.children}</ListGroupItem>
     </Fragment>
      );
};

export default LI;